var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _polygon, _polygon2, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfterHours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 199.37 199.37",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#007161;stroke-miterlimit:10;stroke-width:3px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.3,137.17l-3.55,18.62a6.07,6.07,0,0,1-6,4.94H130.65l-3.43,3.82a2,2,0,0,1-1.49.67H88.94a2,2,0,0,1-1.48-.65L84,160.73H62a6.08,6.08,0,0,1-6-4.94l-3.55-18.62a16.86,16.86,0,0,1,16.86-16.86h74.07A16.86,16.86,0,0,1,160.3,137.17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121,91.81H92.15A20.15,20.15,0,0,0,74,103.26l-8.16,17h81.49l-8.17-17A20.14,20.14,0,0,0,121,91.81Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.15,149.85H96.09a.89.89,0,0,1-.68-.31L85.22,137.66a.9.9,0,0,1,.69-1.48h42.42a.9.9,0,0,1,.68,1.48l-10.18,11.88A.89.89,0,0,1,118.15,149.85Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.06,149.5H132.83a1.39,1.39,0,0,1-.89-2.45l12.47-10.55a1.43,1.43,0,0,1,.88-.33l14.78-.14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.77,149.5H81a1.39,1.39,0,0,0,.9-2.45L69.41,136.5a1.39,1.39,0,0,0-.88-.33L53.76,136"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.09,160.73h23.3a0,0,0,0,1,0,0v6a5.06,5.06,0,0,1-5.06,5.06H64.14a5.06,5.06,0,0,1-5.06-5.06v-6A0,0,0,0,1,59.09,160.73Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.81,160.73h23.3a0,0,0,0,1,0,0v6a5.06,5.06,0,0,1-5.06,5.06H136.87a5.06,5.06,0,0,1-5.06-5.06v-6A0,0,0,0,1,131.81,160.73Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68,114.34v-1.1H57.9a3.1,3.1,0,0,0-3.1,3.1v3.14a1.91,1.91,0,0,0,1.91,1.92H63"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.64,114.34v-1.1h10.11a3.1,3.1,0,0,1,3.11,3.1v3.14a1.92,1.92,0,0,1-1.92,1.92h-6.28"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "113.88 41.08 116.59 46.04 121.56 48.76 116.59 51.47 113.88 56.43 111.17 51.47 106.2 48.76 111.17 46.04 113.88 41.08"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "152.22 58.68 154.06 62.04 157.42 63.88 154.06 65.71 152.22 69.07 150.39 65.71 147.03 63.88 150.39 62.04 152.22 58.68"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.07,37.89A20.81,20.81,0,0,0,64.59,58.17a18.47,18.47,0,1,1,9.19-35.78,20.81,20.81,0,0,0-34.71,15.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterHours);
export default __webpack_public_path__ + "static/media/after-hours.e65d780eaf3b68e1b56f9f5916c828a3.svg";
export { ForwardRef as ReactComponent };